import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';
import {AxisY} from '../utils/math.js';

const tempVec = vec3.create();
/**
 * look-at
 */
export class LookAt extends Component {
    static TypeName = 'look-at';

    /* Properties that are configurable in the editor */

    @property.object({required: true})
    targetObject!: Object3D;

    update(dt: number) {
        this.targetObject.getPositionWorld(tempVec);
        this.object.lookAt(tempVec);
        this.object.rotateAxisAngleDegObject(AxisY, 180);
    }
}
